<template>
  <!-- oncontextmenu: 우클릭방지, onseletstart: 드래그방지, ondragstart: 이미지복사드래그방지 -->
  <div
    id="app"
    oncontextmenu="return false"
    onselectstart="return false"
    ondragstart="return false"
  >
    <keep-alive :include="keepAlive">
      <router-view />
    </keep-alive>
    <confirm-dialog />
    <alert-dialog />
  </div>
</template>

<script type="text/javascript">
// 우클릭 드래그 방지 관련 스크립트
document.oncontextmenu = function () {
  return false;
};
</script>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@import "styles/ui.scss";
</style>
